import { Survey } from 'src/app/models/Survey';
import { Question } from './Question';
import { User } from './User';
export class LoginRequest {
  public email: string;
  public password: string;

  constructor (email: string, password: string) {
    this.email = email;
    this.password = password;
  }
}

export class RegisterRequest {
  public name: string;
  public surname: string;
  public email: string;
  public password: string;

  constructor (name: string,surname: string,email: string, password: string) {
    this.name = name;
    this.surname = surname;
    this.email = email;
    this.password = password;
  }
}

export class RequestPasswordResetRequest {
  public email: string;

  constructor (email: string) {
    this.email = email;
  }
}

export class PasswordResetRequest {
  public userId: number;
  public token: string;
  public password: string;

  constructor (userId: number, token: string, password: string) {
    this.userId = userId;
    this.token = token;
    this.password = password;
  }
}

export class CreateUserRequest {
  public users: User[];

  constructor (surveyName: string, users: User []) {
      this.users =  users;
  }
}

export class CreateSurveyRequest {
  public userIds: [];
  public userIdsRegistered: [];
  public surveyName: string;
  public customerName: string;
  public surveyCustomName: string;
  public surveyDescription: string;
  public surveyFileBase64Cover: string;
  public questions: Question[];
  public isEdit: boolean;
  public contexts: any[] | null;
  public languages: string[] | null;
  public defaultContext: string | null;
  public defaultLanguage: string | null;
  constructor (userIds: [], userIdsRegistered: [], surveyName: string,customerName:string, surveyCustomName :string, surveyDescription  :string,surveyFileBase64Cover: string, questions: Question[], isEdit: boolean = false, contexts: any[] | null, languages: string[] | null, defaultContext: string | null, defaultLanguage: string | null) {
      this.userIds =  userIds;
      this.userIdsRegistered = userIdsRegistered;
      this.surveyName = surveyName;
      this.questions = questions;
      this.customerName = customerName;
      this.surveyCustomName = surveyCustomName;
      this.surveyDescription = surveyDescription;
      this.surveyFileBase64Cover = surveyFileBase64Cover;
      this.isEdit = isEdit;
      this.contexts = contexts;
      this.languages = languages;
      this.defaultContext = defaultContext;
      this.defaultLanguage = defaultLanguage;
  }
}
export class DeleteEcommerceRequest {
  public config_id: number;
  constructor(config_id: number) {
    this.config_id = config_id;
  }
}
export class DeleteSurveyRequest {
  public survey_id: number;
  constructor(survey_id: number) {
    this.survey_id = survey_id;
  }
}
export class FilteredQuestionRequest
{
  public survey_id: number;
  constructor ( survey_id: number) {
    this.survey_id = survey_id;
  }
}

export class QuestionsOverviewChartsRequest
{
  public survey_id: number;
  public periods: any[];
  public filterQuestions: any[] | null;
  public filterCrossQuestion: any | null;
  constructor (survey_id: number, periods: any[], filterQuestions :any[] , filterCrossQuestion : any []) {
    this.survey_id = survey_id;
    this.periods = periods;
    this.filterQuestions = filterQuestions;
    this.filterCrossQuestion = filterCrossQuestion;
  }
}

export class QuestionsOverviewCrossTabChartsRequest
{
  public survey_id: number;
  public periods: any[];
  public filterQuestions: any[] | null;
  public crossQuestion: any | null;
  public currentQuestion : any | null;
  constructor (survey_id: number, periods: any[], filterQuestions :any[] , crossQuestion : any, currentQuestion: any) {
    this.survey_id = survey_id;
    this.periods = periods;
    this.filterQuestions = filterQuestions;
    this.crossQuestion = crossQuestion;
    this.currentQuestion = currentQuestion;
  }
}


export class UploadFileRequest
{
  public file: string;
  constructor ( file: string) {
    this.file = file;
  }
}


export class GetSurveyListRequest {
  public user_id: number;
  public offset: number;
  public limit: number;
  public order: any;
  constructor ( user_id: number, offset: number, limit: number, order: any) {
    this.user_id = user_id;
    this.offset = offset;
    this.limit = limit;
    this.order = order;
  }
}
export class GetSurveyRequest {
  public survey_id: number;
  constructor ( survey_id: number) {
    this.survey_id = survey_id;
  }
}

export class LandingChartsRequest {
  public survey_id: number;
  public periods: any[];

  constructor ( survey_id: number, periods: any[]) {
    this.survey_id = survey_id;
    this.periods = periods;
  }
}

export class SatisfactionChartsRequest
{
  public survey_id: number;
  public periods: any[];
  public filterQuestions: any[] | null;
  constructor (survey_id: number, periods: any[], filterQuestions :any[]) {
    this.survey_id = survey_id;
    this.periods = periods;
    this.filterQuestions = filterQuestions;
  }
}

export class NPSChartsRequest
{
  public survey_id: number;
  public periods: any[];
  public filterQuestions: any[] | null;
  public filterCrossQuestion: any | null;
  constructor (survey_id: number, periods: any[], filterQuestions :any[] , filterCrossQuestion : any []) {
    this.survey_id = survey_id;
    this.periods = periods;
    this.filterQuestions = filterQuestions;
    this.filterCrossQuestion = filterCrossQuestion;
  }
}


export class PolarizationRequest
{
  public survey_id: number;
  public survey_name: string;
  public period: any;
  public filterQuestions: any[] | null;
  public filterCrossQuestion: any | null;
  public offset: number;
  public limit: number;
  constructor (survey_id: number, survey_name: string, period: any, filterQuestions :any[] , filterCrossQuestion : any [], offset: number, limit: number) {
    this.survey_id = survey_id;
    this.survey_name = survey_name;
    this.period = period;
    this.filterQuestions = filterQuestions;
    this.filterCrossQuestion = filterCrossQuestion;
    this.offset = offset;
    this.limit = limit;
  }
}

export class AggregationRequest
{
  public survey_id: number;
  public survey_name: string;
  public periods: any;
  public filterQuestions: any[] | null;
  constructor (survey_id: number, survey_name: string, periods: any, filterQuestions :any[]) {
    this.survey_id = survey_id;
    this.survey_name = survey_name;
    this.periods = periods;
    this.filterQuestions = filterQuestions;
  }
}



export class OpenTextBoxesRequest
{
  public survey_id: number;
  public survey_name: string;
  public period: any;
  public filterQuestions: any[] | null;
  public filterQuestionId: any[];
  public filterTouchpoint : any;
  public filterNps : any;
  public offset: number;
  public limit: number;
  public emotion: string | null;
  public confidence: any;
  constructor (survey_id: number, survey_name: string, period: any, filterQuestions: any[], filterQuestionId: any[], filterTouchpoint: any, filterNps: any, offset: number, limit: number, emotion: string | null, confidence: any) {
    this.survey_id = survey_id;
    this.survey_name = survey_name;
    this.period = period;
    this.filterQuestions = filterQuestions;
    this.filterQuestionId = filterQuestionId;
    this.filterTouchpoint = filterTouchpoint;
    this.filterNps = filterNps;
    this.offset = offset;
    this.limit = limit;
    this.emotion = emotion;
    this.confidence = confidence;
  }
}

export class EmotionalRequest
{
  public survey_id: number;
  public periods: any[];
  public filterQuestions: any[] | null;
  constructor ( survey_id: number, periods: any[], filterQuestions: any[]) {
    this.survey_id = survey_id;
    this.periods = periods;
    this.filterQuestions = filterQuestions;
  }
}

export class TextAreaIdRequest
{
  public survey_id: number;
  constructor(survey_id: number) {
    this.survey_id = survey_id;
  }
}

export class FilteredAiRequest {
  public survey_id: number;
  public survey_name: string;
  public period: any;
  public filterQuestions: any[];
  public filterQuestionId: any[];
  public filterTouchpoint: string;
  public filterNps: any[];

  constructor(survey_id: number, survey_name: string, period: any, filterQuestions: any[], filterQuestionId: any[], filterTouchpoint: string, filterNps: any[]) {
    this.survey_id = survey_id;
    this.survey_name = survey_name;
    this.period = period;
    this.filterQuestions = filterQuestions;
    this.filterQuestionId = filterQuestionId;
    this.filterTouchpoint = filterTouchpoint;
    this.filterNps = filterNps;
  }
}

export class AnswerEmotionRequest {
  public event_id: number;
  public survey_id: string;
  public emotion: string;

  constructor(event_id: number, survey_id: string, emotion: string) {
    this.event_id = event_id;
    this.survey_id = survey_id;
    this.emotion = emotion;
  }
}

export class CreateEcommerceRequest {
  public users: any;
  public userProject: string;
  public hashfile: string;
  public config: EcommerceConfig;

  constructor(users: any, userProject: string, hashfile: string, config: EcommerceConfig) {
    this.users = users;
    this.userProject = userProject;
    this.hashfile = hashfile;
    this.config = config;
  }
}

export type EcommerceTrigger = {
  url: string;
  delay: number;
  showInSubpages: boolean;
}

export type EcommerceConfig = {
  triggers: EcommerceTrigger[];
  ecommerceType: string;
  surveyLink: string;
  coverDesktop: string;
  coverMobile: string;
  surveyDimension: string;
  backgroundColor: string;
  closeColor: string;
  maxDisplay: number;
}

export class GetEcommerceListRequest {
  public user_id: number;
  public offset: number;
  public limit: number;
  public order: any;
  constructor (user_id: number, offset: number, limit: number, order: any) {
    this.user_id = user_id;
    this.offset = offset;
    this.limit = limit;
    this.order = order;
  }
}

export class GetEcommerceRequest {
  public config_id: number;
  constructor (config_id: number) {
    this.config_id = config_id;
  }
}

export class SendEcommerceEmailRequest {
  public email: string;
  public code: string;
  public userProject: string;
  constructor (email: string, code: string, userProject: string) {
    this.email = email;
    this.code = code;
    this.userProject = userProject;
  }
}

